module.exports = __webpack_public_path__ + "img/1515082129.1b5cc21b.jpg";